<template>
  <div class="search-content">
    <div class="paddingContent">
      <div
        style="display: flex;justify-content: space-between;padding-right: 20px;"
      >
        <el-tabs
          @tab-click="handleClick"
          class="scroll-tabs"
          v-model="questionTypeId"
        >
          <el-tab-pane
            :key="item.id"
            v-for="item in titleList"
            :label="item.typeTw"
            :name="item.id"
          >
          </el-tab-pane>
        </el-tabs>
        <div class="btn" @click="showGroup">
          设置分组与排序
        </div>
      </div>
      <div class="MenuBtnWrap_right">
        <div
          class="addbtn"
          @click="
            $router.push({
              path: '/questionDetails',
              query: {
                type: 'add'
              }
            })
          "
          style="margin-right: 20px;"
        >
          新增問題
        </div>
      </div>
      <div class="tableWrap" style="marginTop:30px">
        <el-table height="660px" stripe :data="orderList" style="width:100%;">
          <template slot="empty">
            <div class="no-data-container">
              <img
                src="@/assets/images/common/no_data.png"
                alt="暂无数据"
                :style="{ width: '244px', height: '139px' }"
              />
            </div>
          </template>
          <el-table-column
            v-for="(item, index) in orderListTable"
            :key="index"
            :prop="item.prop"
            :label="item.label"
          >
            <template slot-scope="scope">
              <div v-if="!scope.row[item.prop] && scope.row[item.prop] !== 0">
                -
              </div>
              <div v-else-if="item.prop == 'questionTypeId'">
                {{ changeStatus(scope.row.questionTypeId) }}
              </div>
              <div v-else-if="item.prop == 'answerTw'">
                <div class="htmlItem" v-html="scope.row[item.prop]"></div>
              </div>
              <div v-else-if="item.prop == 'updateTime'">
                {{ $dayjs(scope.row[item.prop]).format("YYYY-MM-DD HH:mm:ss") }}
              </div>
              <div class="htmlItem" v-else>{{ scope.row[item.prop] }}</div>
            </template>
          </el-table-column>
          <el-table-column type="index" label="操作" width="150">
            <template slot-scope="scope">
              <div style="display: flex;">
                <el-dropdown>
                  <span
                    class="el-dropdown-link"
                    style="color: #6c3dea;cursor: pointer;"
                  >
                    排序
                    <el-icon class="el-icon--right">
                      <arrow-down />
                    </el-icon>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :disabled="scope.$index === 0">
                      <div
                        style="cursor: pointer;"
                        @click="moveItem(scope.$index, -1)"
                      >
                        上移
                      </div>
                    </el-dropdown-item>
                    <el-dropdown-item
                      :disabled="scope.$index === orderList.length - 1"
                    >
                      <div
                        style="cursor: pointer;"
                        @click="moveItem(scope.$index, 1)"
                      >
                        下移
                      </div>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <div
                  style="color:#6c3dea;cursor: pointer;margin: 0 10px;"
                  @click="
                    $router.push({
                      path: '/questionDetails',
                      query: {
                        data: scope.row,
                        type: 'edit'
                      }
                    })
                  "
                >
                  編輯
                </div>
                <div
                  style="color:#6c3dea;cursor: pointer;"
                  @click="delQuestion(scope.row)"
                >
                  刪除
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog
      title="設置分組與排序"
      :visible.sync="groupModal"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      width="800px"
      center
      @close="cancelGroup()"
    >
      <div style="display: flex;">
        <div
          style="flex: 1;
          display: flex;
          flex-direction: column;
          align-items: center;"
        >
          <div>
            <div style="display: flex;align-items: center;">
              <div class="btn" @click="addGroup">
                新增
              </div>
              <div style="margin-left: 15px;font-size: 14px;color: #5938E0;">
                {{ copeList.length }}/20
              </div>
            </div>
            <div ref="itemBox" class="itemList">
              <div
                v-for="(item, index) in copeList"
                :key="item.id"
                style="display: flex;align-items: center;"
              >
                <div class="groupItem">
                  <img
                    style="margin-right: 10px;"
                    :src="item.img"
                    @click="upImg(index, item)"
                    v-if="item.img"
                  />
                  <div
                    style="cursor: pointer;margin-right: 10px;"
                    v-else
                    @click="upImg(index)"
                  >
                    <img
                      style="width: 36px;height: 36px;"
                      src="@/assets/images/userData/upimg.png"
                    />
                  </div>
                  <div>
                    <el-input
                      v-model="item.typeCn"
                      placeholder="請輸入分組"
                      v-if="orderlanguageType[index] == 'cn'"
                      maxlength="20"
                      style="width: 300px;margin: 0 24px;"
                    >
                    </el-input>
                    <el-input
                      v-model="item.typeTw"
                      placeholder="請輸入分組"
                      v-if="orderlanguageType[index] == 'tw'"
                      maxlength="20"
                      style="width: 300px;margin: 0 24px;"
                    >
                    </el-input>
                    <el-input
                      v-model="item.typeEn"
                      placeholder="請輸入分組"
                      maxlength="20"
                      v-if="orderlanguageType[index] == 'en'"
                      style="width: 300px;margin: 0 24px;"
                    >
                    </el-input>
                  </div>
                  <el-dropdown>
                    <span class="el-dropdown-link" style="cursor: pointer;">
                      <img
                        style="width: 36px;height: 36px;"
                        src="@/assets/images/userData/sort.png"
                      />
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item
                        :disabled="
                          index === 0 || !item.id || !copeList[index - 1].id
                        "
                      >
                        <div
                          style="cursor: pointer;"
                          @click="moveItemTwo(index, -1, item.id)"
                        >
                          上移
                        </div>
                      </el-dropdown-item>
                      <el-dropdown-item
                        :disabled="
                          index === copeList.length - 1 ||
                            !item.id ||
                            !copeList[index + 1].id
                        "
                      >
                        <div
                          style="cursor: pointer;"
                          @click="moveItemTwo(index, 1, item.id)"
                        >
                          下移
                        </div>
                      </el-dropdown-item>
                      <el-dropdown-item>
                        <div
                          style="cursor: pointer;"
                          @click="delGroup(item, index)"
                        >
                          删除
                        </div>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
                <div style="margin-top: 10px;margin-left: 25px;">
                  <div
                    v-for="(items, indexs) in newslanguageList"
                    :key="indexs"
                    @click="changeLanguage(index, items.type)"
                    :class="indexs == 1 ? 'lglabel lbnone' : 'lglabel'"
                    :style="{
                      background:
                        orderlanguageType[index] == items.type ? '#6C3DEA' : '',
                      color:
                        orderlanguageType[index] == items.type
                          ? '#fff'
                          : '#6C3DEA',
                      display: 'inline-block'
                    }"
                  >
                    {{ items.label }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <el-upload
        ref="uploadRef"
        style="display: none;"
        action=""
        :http-request="uploadRequest"
        :headers="{ Authorization: $cookie.get('auth') }"
        :with-credentials="true"
        :on-remove="titleHandleRemove"
        :on-exceed="$handleExceed.bind(this, 1)"
        :before-upload="beforePicUpload"
        :show-file-list="false"
        accept=".jpg,.jpeg,.png"
        :multiple="false"
        name="multipartFile"
      >
        <el-button size="small" type="primary">上傳主圖</el-button>
      </el-upload>
      <div class="btngroup">
        <div
          class="btn borderBtn"
          style="margin-right:40px"
          @click="cancelGroup"
        >
          取消
        </div>
        <div class="btn" @click="save">确认</div>
      </div>
    </el-dialog>

    <DiaMess v-if="dialogVisible"></DiaMess>
  </div>
</template>

<script>
import DiaMess from "@/components/dialog";
import router from "../../router";
export default {
  data() {
    return {
      listMenuForm: {
        orderNum: "",
        afterSalesNo: "",
        trackingNumber: "",
        name: "",
        mobile: "",
        startTime: "",
        endTime: "",
        orderType: "",
        email: "",
        area: 1
      },
      orderChoice: "afterSalesNo",
      tags: [],
      orderList: [],
      orderListTable: [
        {
          prop: "questionTw",
          label: "問題題目",
          minWidth: "100"
        },
        {
          prop: "answerTw",
          label: "問題問答",
          minWidth: "170"
        },
        {
          prop: "questionTypeId",
          label: "類別",
          minWidth: "190"
        },
        {
          prop: "updateTime",
          label: "更新時間",
          minWidth: "200"
        }
      ],
      newslanguageList: [
        {
          label: "简",
          type: "cn"
        },
        {
          label: "繁",
          type: "tw"
        },
        {
          label: "EN",
          type: "en"
        }
      ],
      currentPage: 1,
      currentPageSize: 20,
      total: 10,
      dialogVisible: false,
      fileList: [],
      titleList: [],
      copeList: [],
      questionTypeId: "",
      groupModal: false,
      orderlanguageType: ["cn"],
      mainPicUrl: "",
      imgIndex: 0
    };
  },
  created() {
    // this.getWenTi();
    this.getTitle();
  },
  activated() {
    // if (this.questionTypeId) {
    //   this.getWenTi();
    // }
  },
  beforeDestroy() {
    console.log("全部销毁", this.questionTypeId);
  },
  methods: {
    getTitle() {
      let _this = this;
      _this
        .$get(`/request/common/question/type `, {}, _this.$GLOBAL.jsonConfig)
        .then(res => {
          if (res.code === "00000") {
            _this.titleList = res.data;
            _this.copeList = JSON.parse(JSON.stringify(res.data));
            _this.questionTypeId = res.data[0].id;
            this.getWenTi();
          }
        });
    },
    getWenTi() {
      let _this = this;
      _this
        .$get(
          `/request/common/question/list?page=${_this.currentPage}&size=50&questionTypeId=${_this.questionTypeId}`,
          {},
          _this.$GLOBAL.jsonConfig
        )
        .then(res => {
          if (res.code === "00000") {
            _this.total = res.data.allRow;
            // res.data.list.forEach(v => {
            //   v.updateTime = _this.$getTime(v.updateTime);
            // });
            _this.orderList = res.data.list;
          } else {
            _this.dialogVisible = true;
            _this.$propMessage(res.message, "error", function() {
              _this.dialogVisible = false;
            });
          }
        });
    },
    delQuestion(scope) {
      let _this = this;
      const params = { ...scope, isValid: 0 };
      _this
        .$confirm("是否刪除該問題?", "提示信息", {
          confirmButtonText: "刪除",
          cancelButtonText: "取消",
          center: true,
          closeOnClickModal: false
        })
        .then(() => {
          // 确认删除的回调
          _this
            .$post(
              `/request/common/question/detail`,
              params,
              _this.$GLOBAL.jsonConfig
            )
            .then(res => {
              if (res.code == "00000") {
                _this.getWenTi();
                _this.$message.success("刪除成功");
              } else {
                _this.$message.error(res.message);
              }
            });
        });
    },
    handleClick(tab, events) {
      this.questionTypeId = tab.name;
      this.getWenTi();
    },
    beforePicUpload(file) {
      let _this = this;
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 20;
      if (!isJPG) {
        _this.dialogVisible = true;
        _this.$propMessage("上傳圖片只能是jpg或者png格式", "error", function() {
          _this.dialogVisible = false;
        });

        return false;
      }

      if (!isLt2M) {
        _this.dialogVisible = true;
        _this.$propMessage("上傳圖片大小不能超過20MB", "error", function() {
          _this.dialogVisible = false;
        });
        return false;
      }

      const isWidth = new Promise((resolve, reject) => {
        let _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.onload = function() {
          if (img.width > 3000 || file.size > 1024 * 1024 * 2) {
            _this.$imageConversion
              .compress(file, {
                quality: 0.3,
                width: 3000
              })
              .then(res => {
                resolve(res);
              });
          } else {
            resolve(file);
          }
        };
        img.src = _URL.createObjectURL(file);
      });
      return isJPG && isLt2M && isWidth;
    },
    titleHandleRemove(file) {
      this.$deleteUidItem(file.uid, this.titlePictureUrl);
      this.$Mint.Toast({ message: "刪除成功" });
      document.getElementsByClassName("el-upload")[0].style.display =
        "inline-block";
      return false;
    },
    uploadRequest(option) {
      const file = option.file;
      const self = this;
      return new Promise((resolve, reject) => {
        const date = self.$dateFormat(new Date(), "yyyy-MM-dd"); // 当前时间
        const dateTime = self.$dateFormat(new Date(), "yyyyMMddhhmmss"); // 当前时间
        let randomStr = self.$randomString(4); //  4位随机字符串
        const extensionName = file.name.substr(file.name.indexOf(".")); // 文件扩展名
        const fileWay = "resource/image/";
        const fileName =
          fileWay + date + "/" + dateTime + "_" + randomStr + extensionName; // 文件名字（相对于根目录的路径 + 文件名）
        // 执行上传
        self.$createOssClient().then(client => {
          client
            .multipartUpload(fileName, file, {
              headers: { "Cache-Control": "public" }
            })
            .then(
              val => {
                if (val.res.statusCode === 200) {
                  self.mainPicUrl = self.$GLOBAL.picFileUrl + val.name;
                  self.copeList[self.imgIndex].img = self.mainPicUrl;
                  //cdn预热
                  self.$cdnFun(self.mainPicUrl).then(res => {});
                  document.getElementsByClassName(
                    "el-upload"
                  )[0].style.display = "none";
                  return val;
                } else {
                  console.log("上传失败1");
                }
              },
              err => {
                console.log(err, "上传失败");
                reject(err);
              }
            );
        });
      });
    },
    showGroup() {
      this.groupModal = true;
      this.orderlanguageType = ["cn"];
      if (this.titleList.length > 0) {
        for (let i = 0; i < this.titleList.length - 1; i++) {
          this.orderlanguageType.push("cn");
        }
      }
      this.copeList = JSON.parse(JSON.stringify(this.titleList));
    },
    cancelGroup() {
      this.groupModal = false;
    },
    save() {
      let _this = this;
      _this.dialogVisible = true;
      _this
        .$post(
          `/request/common/question/type`,
          _this.copeList,
          _this.$GLOBAL.jsonConfig
        )
        .then(res => {
          if (res.code == "00000") {
            _this.$propMessage("操作成功", "success", function() {
              _this.dialogVisible = false;
              _this.groupModal = false;
              _this.getTitle();
            });
          } else {
            _this.$propMessage(res.message, "error", function() {
              _this.dialogVisible = false;
            });
          }
        })
        .catch(err => {});
    },
    changeStatus(val) {
      const questionTypeId = this.titleList.find(v => v.id == val);
      return questionTypeId.typeTw;
    },
    // 分页
    handleCurrentChange(val) {
      let _this = this;
      _this.currentPage = val;
      _this.getWenTi();
    },
    handleSizeChange(val) {
      let _this = this;
      _this.currentPageSize = val;
      _this.getWenTi();
    },
    changeLanguage(index, type) {
      this.$set(this.orderlanguageType, index, type);
    },
    moveItem(index, direction) {
      let _this = this;
      const params = [this.orderList[index], this.orderList[index + direction]];
      _this
        .$post(`request/common/question/seq`, params, _this.$GLOBAL.jsonConfig)
        .then(res => {
          if (res.code == "00000") {
            _this.getWenTi();
            this.$message({
              message: "排序成功",
              type: "success",
              center: true,
              duration: 1000
            });
          } else {
            _this.$message.error(res.message);
          }
        });
    },
    moveItemTwo(index, direction, id) {
      if (id && this.copeList[index + direction].id) {
        const params = [this.copeList[index], this.copeList[index + direction]];
        this.$post(
          `request/common/question/type/seq `,
          params,
          this.$GLOBAL.jsonConfig
        ).then(res => {
          if (res.code == "00000") {
            this.getTitle();
            this.$message({
              message: "排序成功",
              type: "success",
              center: true,
              duration: 1000
            });
          } else {
            this.$message.error(res.message);
          }
        });
      } else {
        this.$message.error("新增数据请先保存");
      }
    },
    upImg(index, item) {
      console.log(item);

      this.imgIndex = index;
      const input = this.$refs.uploadRef.$el.querySelector(
        'input[type="file"]'
      );
      input.click();
    },
    addGroup() {
      if (this.copeList.length >= 20) return;
      this.orderlanguageType.push("cn");
      this.copeList.push({
        id: null,
        typeTw: "",
        typeEn: "",
        typeCn: "",
        seq: null,
        img: null,
        isValid: 1
      });
      this.$nextTick(() => {
        const box = this.$refs.itemBox;
        box.scrollTop = box.scrollHeight;
      });
    },
    delGroup(item, index) {
      const params = this.copeList[index];
      params.isValid = 0;
      this.$dels(
        `/request/common/question/type`,
        params,
        this.$GLOBAL.jsonConfig
      )
        .then(res => {
          if (res.code == "00000") {
            this.$message({
              message: "刪除成功",
              type: "success",
              center: true,
              duration: 1000
            });
            this.orderlanguageType.splice(index, 1);
            this.copeList.splice(index, 1);
            this.getTitle();
          } else {
            this.$warnMessage(res.message);
          }
        })
        .catch(err => {
          this.$warnMessage(err);
        });
    }
  },
  components: {
    DiaMess
  },
  watch: {
    orderStatus(val) {
      console.log("val", val);
    }
  }
};
</script>

<style lang="less" scoped>
.search-content {
  width: 100%;
  .ListMenu {
    display: flex;
  }
  .MenuBtnWrap {
    justify-content: flex-start;
    margin-top: 30px;
    .MenuBtnWrap_left {
      width: 100%;
      color: #292929;
      display: flex;
      align-items: center;
      overflow: auto;
      span:first-child {
        flex-shrink: 0;
      }

      .tags {
        width: 94%;
        overflow: auto;
        white-space: nowrap;
        display: flex;
        justify-content: flex-start;
      }
    }
  }
  .MenuBtnWrap_right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}
@media screen and (min-width: 769px) {
  .ListMenu {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .searchForm {
      flex: 1;
      display: flex;
      justify-content: flex-start;

      .searchItem {
        margin-right: 0.4rem;
        margin-bottom: 0.2rem;
      }
    }

    .MenuBtnWrap {
      flex: 1;
    }
  }
}
@media screen and (max-width: 769px) {
  .MenuBtnWrap_right {
    margin-top: 0px;
  }
}
.groupItem {
  display: flex;
  align-items: center;
  border: 1px solid #e4e4e4;
  border-radius: 4px;
  padding: 25px;
  margin-top: 10px;
  img {
    width: 36px;
    height: 36px;
    cursor: pointer;
    object-fit: cover;
  }
}
.lglabel {
  height: 38px;
  line-height: 38px;
  text-align: center;
  padding: 0 20px;
  border: 1px solid #dcdfe6;
  cursor: pointer;
}
.lbnone {
  border-left-width: 0px;
  border-right-width: 0px;
}
.btngroup {
  margin-top: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btn {
  text-align: center;
}
.scroll-tabs {
  max-width: 90%;
}
/* 让 tab 导航区可以横向滚动 */
.scroll-tabs ::v-deep(.el-tabs__nav-wrap) {
  overflow-x: auto;
  overflow-y: hidden;
}

/* 隐藏 Element 自带的左右箭头（如果不需要） */
.scroll-tabs ::v-deep(.el-tabs__nav-prev),
.scroll-tabs ::v-deep(.el-tabs__nav-next) {
  display: none;
}
/deep/ .el-tabs__item:last-child {
  padding-right: 30px !important;
}
/* 让 nav 不换行，横向排列 */
.scroll-tabs ::v-deep(.el-tabs__nav) {
  display: flex;
  flex-wrap: nowrap;
  white-space: nowrap;
}

/* 隐藏滚动条（可选） */
.scroll-tabs ::v-deep(.el-tabs__nav-wrap::-webkit-scrollbar) {
  display: none;
}
/deep/.htmlItem {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  line-height: 1.4;
  img {
    max-width: 100px;
    object-fit: contain;
  }
}
/deep/.el-icon-arrow-right {
  font-size: 16px;
}
/deep/ .el-icon-arrow-left {
  font-size: 16px;
}
.addbtn {
  width: 1rem;
  height: 0.35rem;
  line-height: 0.35rem;
  border: 1px solid #6c3dea;
  border-radius: 4px;
  color: #6c3dea;
  cursor: pointer;
}
.itemList {
  height: 400px;
  overflow: auto;
  margin-top: 20px;
}
/deep/ .el-icon-close {
  font-size: 24px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/question/questionItems.vue